export default function replacedHtmlTags(str: string): string {
  const regexp = /<\/?br\/?>/g;

  return str.replace(regexp, '\n');
}
